(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/header-portal/header-portal.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/header-portal/header-portal.js');
"use strict";


const {
  createPortal
} = ReactDOM;
const {
  useContext
} = React;
const {
  User
} = svs.ticket_partner.sharedComponents.headerPortal.components;
const HeaderPortal = () => {
  const portalEl = document.querySelector('#login-portal');
  const {
    isLoggedIn
  } = useContext(svs.ticket_partner.UserContext);
  if (portalEl && isLoggedIn) {
    return createPortal( React.createElement(User, null), portalEl);
  }
  return null;
};
svs.ticket_partner.sharedComponents.headerPortal.HeaderPortal = HeaderPortal;

 })(window);